export interface BusinessCardRequest {
  requesterName: string;
  requesterEmail: string;
  requesterCompany: string;
  requestDate: string; // mm/dd/yyy
}
